import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Sidstorlek',
	PageOrientation: 'Sidorientering',
	Format: 'Format',
	DPI: 'DPI',
	Generate: 'Generera',
	LanguageName: 'Svenska',
	LanguageCode: 'sv'
};

export default translation;
